import styled from 'styled-components';
import { colors } from 'shared/styles/settings';
import Label from 'shared/components/label';

export const Error = styled(Label)`
  color: ${colors.danger} !important;
  font-size: 0.75rem;
  font-weight: bold;
  line-height: 0.875rem;
  margin-top: 0.5rem;
  width: 100%;
`;
export default Error;
